var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldHierarchySquare3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm4.51 10.74h-.02l-2.06-.01h-.01c-.76 0-1.42.51-1.62 1.24.89.28 1.54 1.11 1.54 2.09 0 1.21-.99 2.2-2.2 2.2-1.21 0-2.2-.99-2.2-2.2 0-.89.54-1.66 1.3-2V9.7a2.05 2.05 0 0 1-1.3-1.9c0-1.13.92-2.05 2.05-2.05s2.05.92 2.05 2.05c0 .87-.54 1.6-1.3 1.9v2.02c.49-.31 1.07-.49 1.68-.49h.01l2.06.01c1.18.04 2.23-.72 2.65-1.82-.49-.38-.81-.96-.81-1.62 0-1.13.92-2.05 2.05-2.05s2.05.92 2.05 2.05c.01 1.06-.8 1.92-1.83 2.03a4.341 4.341 0 0 1-4.09 2.91z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldHierarchySquare3);
export default __webpack_public_path__ + "static/media/vuesax-bold-hierarchy-square-3.8a3ba9d8d11a6d8c22e214cef4366d55.svg";
export { ForwardRef as ReactComponent };